import { getSignupHref, isSignupShowing } from "../common/loginPage";
import {
  styleObjectGetBGasColor,
  styleObjectGetColor,
} from "../common/StyleSeter";

const SignupButton = ({
  site,
  variant = "desktop",
}: {
  site: any;
  variant?: "desktop" | "mobile";
}) => {
  if (!isSignupShowing(site)) return null;

  const href = getSignupHref(site);

  return (
    <li>
      <a
        className="btn-signup"
        style={
          variant === "mobile"
            ? styleObjectGetBGasColor(site?.colorSchema)
            : styleObjectGetColor(site?.colorSchema)
        }
        href={href || undefined}
        target={href ? "_blank" : undefined}
        rel={href ? "noopener noreferrer" : undefined}
        onClick={(event) => {
          if (!href) event.preventDefault();
        }}
      >
        Sign-Up
      </a>
    </li>
  );
};

export default SignupButton;
